<template>
  <div id="main">
    <div class="assessment-banner">
      <img alt="" src="@/assets/img/dc/banner.png" />
      <div class="assessment-info" v-if="dataDetail && dataDetail.userInfo">
        <span>姓名：</span><label>{{ dataDetail.userInfo.userName }}</label>
        <span>经销商：</span><label> {{ dataDetail.userInfo.orgName }}</label>
        <span>职位：</span><label>{{ dataDetail.userInfo.jobTitle }}</label>
        <span>评估结果：</span><label>{{ dataDetail.userInfo.assessResult }}</label>
      </div>
    </div>
    <div style="background: #ffffff">
      <!--      发展进度-->
      <div class="assessment-msg_1">
        <div style="background: #f9f9f9">
          <div>
            <div style="height: 20px"></div>
            <div style="height: 90px; margin: 0 80px 0 70px">
              <el-row>
                <el-col :span="4" style="font-weight: bold; font-size: 18px">
                  <div class="progress-title" style="padding: 20% 0 0 10px">
                    发展进度>
                  </div>
                </el-col>
                <el-col :span="1">
                  <div style="background: #f9f9f9; height: 60px"></div>
                </el-col>
                <el-col :span="3">
                  <span style="text-align: center; display: block"
                    ><img alt="" width="60px" src="@/assets/img/dc/1228_1.png"
                  /></span>
                  <div style="height: 10px"></div>
                  <div
                    style="
                      height: 20px;
                      color: #1e68d4;
                      text-align: center;
                      display: block;
                    "
                  >
                    发展计划
                  </div>
                </el-col>
                <el-col :span="3">
                  <span
                    v-if="dataDetail.developProgress[1].status === '10'"
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_0_1.png"
                  /></span>
                  <span
                    v-if="dataDetail.developProgress[1].status !== '10'"
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_0.png"
                  /></span>
                </el-col>
                <el-col :span="3">
                  <span
                    v-if="dataDetail.developProgress[1].status === '10'"
                    style="text-align: center; display: block"
                    ><img alt="" width="60px" src="@/assets/img/dc/1228_2_1.png"
                  /></span>
                  <span
                    v-if="dataDetail.developProgress[1].status !== '10'"
                    style="text-align: center; display: block"
                    ><img alt="" width="60px" src="@/assets/img/dc/1228_2.png"
                  /></span>
                  <div style="height: 10px"></div>
                  <div
                    v-if="dataDetail.developProgress[1].status === '10'"
                    style="
                      height: 20px;
                      text-align: center;
                      display: block;
                      color: #696969;
                    "
                  >
                    区域反馈
                  </div>
                  <div
                    v-if="dataDetail.developProgress[1].status !== '10'"
                    style="
                      height: 20px;
                      text-align: center;
                      display: block;
                      color: #1e68d4;
                    "
                  >
                    区域反馈
                  </div>
                </el-col>

                <el-col :span="3">
                  <span
                    v-if="dataDetail.developProgress[2].status === '10'"
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_0_1.png"
                  /></span>
                  <span
                    v-if="dataDetail.developProgress[2].status !== '10'"
                    style="text-align: center; display: block"
                    ><img alt="" height="60px" src="@/assets/img/ac/1223_0.png"
                  /></span>
                </el-col>
                <el-col :span="3">
                  <span
                    v-if="dataDetail.developProgress[2].status === '10'"
                    style="text-align: center; display: block"
                    ><img alt="" width="60px" src="@/assets/img/ac/1223_5_1.png"
                  /></span>
                  <span
                    v-if="dataDetail.developProgress[2].status !== '10'"
                    style="text-align: center; display: block"
                    ><img alt="" width="60px" src="@/assets/img/ac/1223_5.png"
                  /></span>
                  <div style="height: 10px"></div>
                  <div
                    v-if="dataDetail.developProgress[2].status === '10'"
                    style="
                      height: 20px;
                      text-align: center;
                      display: block;
                      color: #696969;
                    "
                  >
                    完成
                  </div>
                  <div
                    v-if="dataDetail.developProgress[2].status !== '10'"
                    style="
                      height: 20px;
                      text-align: center;
                      display: block;
                      color: #1e68d4;
                    "
                  >
                    完成
                  </div>
                </el-col>
              </el-row>
              <div style="height: 10px"></div>
            </div>
          </div>
          <div style="height: 10px"></div>
        </div>
      </div>
      <div style="background: #ffffff; height: 10px"></div>
    </div>
    <div style="background-color: #f9f9f9">
       <div :class="'assessment-msg-dev'">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>发展计划</span>
          </div>
          <el-row>
            <el-col :span="6">
              <span>必修课</span><label>{{ dataDetail.developPlan.isRequired }}</label>
            </el-col>
            <el-col :span="6">
              <div>
                <span>发展期</span
                ><label>{{ dataDetail.developPlan.developmentOf }}</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="assessment-title"></div>
            </el-col>
            <el-col :span="4">
              <div style="position: absolute; right: 0">
                <!-- 是否可修改（1：显示 2:不显示） -->
                <el-button
                  type="primary"
                  @click="sendDevelopmentCenterEdit"
                  v-if="
                    $hasPermission('ACDC0001002') &&
                    dataDetail.developCenterResult.statusName !== '' &&
                    dataDetail.developPlan.isEdit === '1'
                  "
                  >发展计划调整
                </el-button>
                <el-button
                  type="primary"
                  @click="sendCourse"
                  v-if="$hasPermission('ACDC0001003')"
                  >课程报名
                </el-button>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-top: 15px !important">
            <el-col :span="6">
              <div>
                <span>课程完成状态</span
                ><label>{{ dataDetail.developPlan.courseCompleteStatus }}</label>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <span>课程完成日期</span
                ><label>{{ dataDetail.developPlan.courseCompleteDate }}</label>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-top: 15px !important">
            <el-col :span="4">
              <div class="assessment-title">
                <a style="color: #409eff; text-decoration: none">
                  <span
                    style="font-size: 14px; font-weight: 600; margin-right: 10px"
                    v-if="!isShowCourse"
                    class="addPointer"
                    @click="clickShowCourse"
                  >
                    查看发展计划
                  </span>
                  <span
                    style="font-size: 14px; font-weight: 600; margin-right: 10px"
                    v-if="isShowCourse"
                    class="addPointer"
                    @click="clickShowCourse"
                  >
                    收起发展计划
                  </span>
                  <span v-if="!isShowCourse">
                    <em class="el-icon-arrow-right" style="font-size: 14px"></em>
                  </span>
                  <span v-if="isShowCourse">
                    <em class="el-icon-arrow-down" style="font-size: 14px"></em>
                  </span>
                </a>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="24">
              <span>待发展能力项:</span
              ><label v-html="dataDetail.developPlan.waitCompetencyModelList"></label>
            </el-col>
          </el-row>
          <el-row style="margin-top: 15px !important" v-if="isShowCourse">
            <el-col :span="24">
              <div class="developmentTable">
                <el-table
                  :data="dataDetail.developPlan.courseOfDevelopList"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="courseCode"
                    label="课程代码"
                    header-align="center"
                    align="center"
                    :show-overflow-tooltip="true"
                    width="200"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="courseName"
                    label="课程名称"
                    header-align="center"
                    align="center"
                    :show-overflow-tooltip="true"
                    width="330"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="courseTypeName"
                    label="学习对象类型"
                    header-align="center"
                    align="center"
                    width="120"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="isRequired"
                    label="必修/选修"
                    header-align="center"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="courseCompleteStatus"
                    label="完成状态"
                    header-align="center"
                    align="center"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <!--      业务/能力反馈-->
      <div class="assessment-msg">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>区域反馈</span>
          </div>
          <div style="height: 30px">
            <el-row>
              <el-col :span="4">
                <span>结果</span
                ><label>{{ dataDetail.abilityFeedback.statusName }}</label>
              </el-col>
              <el-col :span="6">
                <span>反馈日期</span
                ><label>{{ dataDetail.abilityFeedback.feedbackDate }}</label>
              </el-col>
              <el-col :span="10">
                <div class="assessment-title"></div>
              </el-col>
              <el-col :span="4">
                <div style="position: absolute; right: 0">
                  <!-- 是否可修改（1：编辑 0：查看 2:不显示） -->
                  <el-button
                    type="primary"
                    @click="sendFeedback()"
                    v-if="
                      $hasPermission('ACDC0001004') &&
                      dataDetail.abilityFeedback.isEdit === '1'
                    "
                    >区域反馈
                  </el-button>
                  <el-button
                    type="primary"
                    @click="sendFeedback()"
                    v-if="
                      $hasPermission('ACDC0001004') &&
                      dataDetail.abilityFeedback.isEdit === '0'
                    "
                    >查看反馈
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <!--      发展中心结果-->
      <div class="assessment-msg">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>发展中心结果</span>
          </div>
          <div>
            <el-row>
              <el-col :span="4">
                <span>结果</span
                ><label>{{ dataDetail.developCenterResult.statusName }}</label>
              </el-col>
              <el-col :span="6">
                <span>完成日期</span
                ><label>{{ dataDetail.developCenterResult.completeDate }}</label>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <!--      补充说明-->
      <div class="assessment-msg">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>补充说明</span>
          </div>
          <div>
            <ul>
              <li class="one">
                  发展计划中的课程完成情况将在次日更新
              </li>
            </ul>
            <br/>
            <ul>
              <li class="one">
                  如果您对于发展中心有疑问或建议，请发送邮件至：Trainingorganization.MT@bmw-brilliance.cn ，或拨打电话 010-8455 7446
              </li>
            </ul>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @author zhengf
 */
export default {
  name: "developmentCenterInfo",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      roleType: "",
      isShowCourse: true, // 发展计划列表展开
      recruitmentId: this.$route.query.recruitmentId,
      dataDetail: {},
      assessmentResult: "",
      dataDetailTemp: {
        userInfo: {
          //用户信息
          assessResult: "低于基础要求",
          jobId: 250,
          orgName: "南京宝宁",
          jobTitle: "市场经理",
          userName: "焦柯",
          userId: 257510,
        },
        jobStatus: {
          //职位状态
          onDutyDate: "",
          statusName: "",
          status: "",
        },
        developCenterResult: {
          //发展中心结果
          statusName: "",
          completeDate: "2020-11-12",
          status: "",
        },
        abilityFeedback: {
          //业绩能力反馈
          feedbackDate: "",
          statusName: "",
          status: "",
        },
        developPlan: {
          //发展计划
          courseOfDevelopList: [
            {
              isRequired: "必修",
              courseType: "10",
              courseTypeName: "面授课",
              courseName: "测试报名人数",
              dcId: "1326822890018344961",
              courseNameCn: "测试报名人数",
              courseCode: "C20201109003",
              competencyModelName: "",
              competencyModelId: "",
              recruitmentId: "1326802436629106689",
              courseCompleteStatus: "未完成",
              acplanId: "",
            },
            {
              isRequired: "选修",
              courseType: "10",
              courseTypeName: "面授课",
              courseName: "市场经理培训-一级",
              dcId: "1326822890018344961",
              courseNameCn: "市场经理培训-一级",
              courseCode: "B_SA_FF_CN_4008",
              competencyModelName: "",
              competencyModelId: "",
              recruitmentId: "1326802436629106689",
              courseCompleteStatus: "未完成",
              acplanId: "",
            },
          ],
          jobId: "250",
          dcId: "",
          developmentOf: "2020-12~2021-07", //发展期
          isEdit: "1", //是否可修改 1：是 0：否
          courseCompleteDate: "", //课程完成时间
          recruitmentId: "1326802436629106689",
          waitCompetencyModelList: [
            //待发展能力项
            "分析决策",
            "职业素养",
          ],
          courseCompleteStatus: "未完成",
        },
        developProgress: [
          //球
          {
            step: 1,
            status: "20", //20亮  10灰
          },
          {
            step: 2,
            status: "10",
          },
          {
            step: 3,
            status: "10",
          },
        ],
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 数据初始化
    init() {
      console.log("developmentCenterInfo init");
      console.log(this.recruitmentId);
      console.log(this.$route.query.recruitmentId);
      //  console.log( this.$hasPermission('ACDC0000001'))
      if (this.$hasPermission("ACDC0000001")) {
        this.roleType = "acdcAdmin";
      } else if (this.$hasPermission("ACDC0000002")) {
        this.roleType = "areaManager";
      }
      console.log(this.roleType);
      this.$request
        .post("/actionplan/actionPlan/getDevelopCenterDetail", {
          // recruitmentId: '1326802436629106689'
          recruitmentId: this.$route.query.recruitmentId,
          roleType: this.roleType,
        })
        .then((res, total, code, data) => {
          console.log("getAcPlanInfoDetail");
          console.log(data);
          this.dataDetail = data.data;

          let waitCompetencyModelList = "";
          if (data.data.developPlan.waitCompetencyModelList) {
            for (
              var i = 0;
              i < data.data.developPlan.waitCompetencyModelList.length;
              i++
            ) {
              waitCompetencyModelList =
                waitCompetencyModelList +
                data.data.developPlan.waitCompetencyModelList[i] +
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
            }
          }
          this.$set(
            this.dataDetail.developPlan,
            "waitCompetencyModelList",
            waitCompetencyModelList
          );
        })
        .catch((err) => {
          console.log(err)
        });

      this.$request
        .get("/acdc/finalassessmenresult/getInfoByRecruitmentId", {
          recruitmentId: this.$route.query.recruitmentId,
        })
        .then((res, total, code, data) => {
          console.log("acdc/finalassessmenresult/getInfoByRecruitmentId");
          console.log(data);
          this.assessmentResult = data.data.assessmentResult;
          console.log(this.assessmentResult);
          console.log(this.assessmentResult !== "PassBasicLine");
          // assessmentResult = PassBasicLine 符合岗位要求
          // 隐藏
          // 发展计划中： 发展期 课程完成状态 课程完成日前
          // 业绩/能力反馈
          // 发展中心结果
        })
        .catch((err) => {
          console.log(err)
        });
    },

    // 点击发展计划
    clickShowCourse() {
      if (this.isShowCourse) {
        this.isShowCourse = false;
      } else {
        this.isShowCourse = true;
      }
    },

    // 跳转 编辑发展计划
    sendDevelopmentCenterEdit() {
      this.$router.push({
        name: "acdc-developmentCenter-sendDevelopmentCenterEdit",
        query: {
          recruitmentId: this.dataDetail.developPlan.recruitmentId,
          jobId: this.dataDetail.developPlan.jobId,
        },
      });
    },

    // 跳转 业绩/能力反馈
    sendFeedback() {
      this.$router.push({
        name: "acdc-developmentCenter-abilityFeedbackEdit",
        query: {
          recruitmentId: this.dataDetail.developPlan.recruitmentId,
        },
      });
    },

    // 跳转 课程报名
    sendCourse() {

      this.$router.push({
        name: 'learning-offering-offeringlistdealerAdmin',
        query: {
          page: '1',
          limit: '10',
          language: 'Cn'
        }
      })
    },
  },

  activated() {
    this.init();
  },
  //创建前：
  beforeCreate() {
    console.log('beforeCreate')
  },
  // 创建完成 实例已经创建完成之后被调用

  //挂载前：在挂载开始之前被调用：相关的 render 函数首次被调用
  beforeMount() {
    console.log('beforeMount')
  },
  // 挂载完成：
  mounted() {
    console.log('mounted')
  },
  // 即将更新渲染: 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  beforeUpdate() {
    console.log('beforeUpdate')
  },
  // 更新成功
  updated() {
    console.log('updated')
  },
  // 实例销毁之前调用
  beforeDestroy() {
    console.log('beforeDestroy')
  },
  //Vue 实例销毁后调用
  destroyed() {
    console.log('destroyed')
  },
};
</script>
<style>
.assessmentPolicyClick .el-checkbox {
  font-size: 14px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 5px;
}

.developmentTable .el-table th {
  background: #ffffff !important;
  border-right: 1px #ffffff solid !important;
}

.developmentTable .el-table th > .cell {
  color: #333333;
  font-weight: 700;
}

.developmentTable .el-table--enable-row-transition .el-table__body td {
  border-right: 1px #ffffff solid !important;
}

.box-card .el-col-6 {
  text-align: left;
}
</style>
<style lang="scss" scoped>
.fujianButton {
  padding: 3px 20px !important;
  border-radius: 5px !important;
}

.capabilityItem:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

main .pkg-content {
  background-color: #f9f9f9;
  // padding: 20px;
  position: relative;
}
main .el-card__body {
  padding: 0 20px 20px;
}
// 2020-12-14 去掉横条
.assessment-msg {
  margin: 0 50px;
  /*border-top: 1px solid #dbdbdb;*/
  padding: 10px 0;
  position: relative;
}

main .assessment-msg_1 {
  margin: 0 50px;
  /*border-top: 1px solid #dbdbdb;*/
  /*padding: 0 10px 0;*/
  position: relative;
}

.assessment-msg-dev {
  margin: 0 50px;
  padding: 30px 0;
  position: relative;
}

.assessment-msg .assessment-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.assessment-msg-dev .assessment-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.assessment-msg span {
  font-weight: 600;
  margin-right: 20px;
}

.assessment-msg-dev span {
  font-weight: 600;
  margin-right: 20px;
}

.assessment-msg label {
  // font-weight: 600;
  /* margin-right: 60px; */
}

.assessment-msg .assessment-btn {
  position: absolute;
  right: 0;
  top: 50%;
  width: 150px;
  transform: translateY(-50%);
}

.assessment-msg-dev .assessment-btn {
  position: absolute;
  right: 0;
  top: 50%;
  width: 150px;
  transform: translateY(-50%);
}

.pkg-search-box {
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 4px;
  overflow: hidden;
}

.el-dialog__body {
  padding: 5px 20px !important;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.el-dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}

.assessment-banner {
  position: relative;
}

.assessment-banner img {
  display: inline-block;
  width: 100%;
}

.assessment-info {
  position: absolute;
  top: 10px;
  right: 10px;
}

.assessment-info span {
  font-weight: 600;
}

.assessment-info label {
  margin-right: 20px;
}

/*进度条 */
.assessment-progress {
  width: 80%;
  height: 10%;
  margin: 0 80px 0 100px;
  /*padding: 20px 0 40px 0;*/
  position: relative;

  .progress-title {
    position: absolute;
    top: 35.7%;
    left: -1%;
    font-weight: bold;
    font-size: 16px;
  }
}

.assessment-progress span {
  width: 19%;
  display: inline-block;
  margin-top: 15px;
  max-width: 268px;

  &:first-child {
    width: 20%;
  }
}

.assessment-progress span img {
  display: inline-block;
  width: 100%;
}

.assessment-progress .disabled {
  -webkit-filter: grayscale(100%);
  /* Chrome, Safari, Opera */
  filter: grayscale(100%);
  pointer-events: none;
}

.assessment-progress .disabledImg {
  -webkit-filter: grayscale(100%);
  /* Chrome, Safari, Opera */
  filter: grayscale(100%);
  pointer-events: none;
}
/* 弹出框*/
.assessment-result {
  margin-top: -30px;
  display: inline-block;
}

.assessment-result label {
  margin-right: 20px;
  white-space: nowrap;
  line-height: 40px;
}

.assessment-form {
  box-shadow: 0 0 5px #978787;
  padding: 20px 30px;
}

.assessment-form-label {
  font-size: 14px;
  margin-bottom: 20px;
  display: inline-block;
}

.addPointer {
  cursor: pointer;
  text-decoration: none;
}
</style>
